import React from 'react';
import { IntegrityForm as FormFields } from 'features/settings/integrityManagement/helpers/integrityManagement.constants';
import { Grid } from '@material-ui/core';
import { useFormikContext } from 'formik';
import SelectTextFieldFormik from 'app/components/form/formik/SelectTextFieldFormik';
import { List } from 'immutable';
import { useEffect } from 'react';

const SelectPicklistOptionComponent = ({ updateValue, integrity, xs = 6 }) => {
  const { values } = useFormikContext();
  const getId = (item) => item.id;
  const getName = (item) => item.name;
  const picklistObject = values[FormFields.PICKLIST_OPTIONS];
  const items = picklistObject.map((picklist) => ({
    id: picklist.integrityDetailId,
    code: picklist.integrityId,
    name: picklist.title,
  }));

  useEffect(() => {
    if (integrity.value.id !== values.value) updateValue(values);
    // eslint-disable-next-line
  }, [values]);

  return (
    <Grid item xs={xs}>
      <SelectTextFieldFormik
        getItemName={getName}
        placeholder="Select"
        value={values[FormFields.VALUE]}
        getItemValue={getId}
        items={List(items)}
        name={FormFields.VALUE}
        displayEmpty={false}
      />
    </Grid>
  );
};

export default SelectPicklistOptionComponent;
